import { render, staticRenderFns } from "./QuestionReplyModal.vue?vue&type=template&id=a04b4832&scoped=true&"
import script from "./QuestionReplyModal.vue?vue&type=script&lang=js&"
export * from "./QuestionReplyModal.vue?vue&type=script&lang=js&"
import style0 from "./QuestionReplyModal.vue?vue&type=style&index=0&id=a04b4832&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a04b4832",
  null
  
)

export default component.exports